import React from 'react';
import { Box } from '@mui/material';
import { SimpleForm, TextInput, BooleanInput, ReferenceInput, AutocompleteInput, required, maxLength, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { noCharactersFromList } from '@/components/global/validators/customValidators.jsx';
import { contractorFilterToQuery, aliasFilterToQuery } from '@/helpers/filters/filterToQuery.js';
import GroupDeviceFileInput from '@/components/deviceGroup/GroupDeviceFileInput.jsx';

const DeviceGroupForm = ({ toolbar }) => {
    const translate = useTranslate();
    return (
        <SimpleForm toolbar={toolbar}>
            <TextInput
                source='name'
                label={translate('resources.deviceGroup.fields.name')}
                validate={[
                    required(translate('common.validation.required')),
                    maxLength(150, translate('common.validation.maxLength', { count: 150 })),
                    noCharactersFromList('$%^"",.;'),
                ]}
                fullWidth
            />
            <Box className='autocomplete-parent'>
                <ReferenceInput source='contractorId' reference='contractor'>
                    <AutocompleteInput
                        filterToQuery={contractorFilterToQuery}
                        validate={required(translate('common.validation.required'))}
                        fullWidth={true}
                        disablePortal={true}
                        label={translate('common.contractor')}
                    />
                </ReferenceInput>
            </Box>
            <TextInput
                source='config'
                label={translate('resources.deviceGroup.labels.config')}
                validate={[required(translate('common.validation.required'))]}
                multiline
                fullWidth
            />
            <Box className='autocomplete-parent'>
                <ReferenceInput source='targetSoftwareMcuId' reference='software-alias' filter={{ 'software.type': 'MCU' }}>
                    <AutocompleteInput
                        filterToQuery={aliasFilterToQuery}
                        fullWidth={true}
                        label={translate('resources.deviceGroup.labels.expectedMcuVersion')}
                        disablePortal={true}
                    />
                </ReferenceInput>
            </Box>
            <Box className='autocomplete-parent'>
                <ReferenceInput source='targetSoftwareSocId' reference='software-alias' filter={{ 'software.type': 'SOC' }}>
                    <AutocompleteInput
                        filterToQuery={aliasFilterToQuery}
                        fullWidth={true}
                        label={translate('resources.deviceGroup.labels.expectedSocVersion')}
                        disablePortal={true}
                    />
                </ReferenceInput>
            </Box>
            <Box sx={{ marginLeft: '10px' }}>
                <BooleanInput size={'small'} source='isActive' defaultValue={true} label={translate('common.active')} />
            </Box>
            <GroupDeviceFileInput sx={{ width: '100%' }} />
        </SimpleForm>
    );
};

DeviceGroupForm.propTypes = {
    toolbar: PropTypes.node,
};

export default DeviceGroupForm;
